/**
 * Calculate the distance between two geographic coordinates using the Haversine formula
 * @param {number} lat1 - Latitude of the first point
 * @param {number} lng1 - Longitude of the first point
 * @param {number} lat2 - Latitude of the second point
 * @param {number} lng2 - Longitude of the second point
 * @returns {number} Distance in kilometers
 */
export const calculateDistance = (lat1, lng1, lat2, lng2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = toRadians(lat2 - lat1);
    const dLng = toRadians(lng2 - lng1);
    
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    
    return distance;
};

/**
 * Convert degrees to radians
 * @param {number} degrees 
 * @returns {number} Radians
 */
const toRadians = (degrees) => {
    return degrees * (Math.PI / 180);
};

/**
 * Check if user is within a certain radius of their saved location
 * @param {Object} currentLocation - Current location with latitude and longitude
 * @param {Object} savedLocation - Saved location with latitude and longitude
 * @param {number} radiusKm - Radius in kilometers (default 25km)
 * @returns {boolean} True if within radius, false otherwise
 */
export const isWithinRadius = (currentLocation, savedLocation, radiusKm = 25) => {
    if (!currentLocation || !savedLocation) return false;
    
    const distance = calculateDistance(
        Number(currentLocation.latitude),
        Number(currentLocation.longitude),
        Number(savedLocation.latitude),
        Number(savedLocation.longitude)
    );
    
    return distance <= radiusKm;
};

/**
 * Session key for storing location preference dialog shown state
 */
export const LOCATION_PREFERENCE_SHOWN_KEY = 'locationPreferenceDialogShown';

/**
 * Session key for storing selected location preference
 */
export const LOCATION_PREFERENCE_KEY = 'selectedLocationPreference';